module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ec7NqI/tc-custom/9781459251816.jpg?1720015951328",
      "alt": "This image is the cover for the book Giordanni's Proposal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Giordanni's Proposal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author, a billionaire proposes marriage to an innocent woman to protect his family and falls in love with his fiancée.")]), _c('br'), _c('br'), _vm._v("A marriage proposal—Italian-style!"), _c('br'), _c('br'), _vm._v("Beth was left breathless when gorgeous Italian tycoon Dex Giordanni proposed marriage—within days of meeting her! But then she overheard a conversation that chilled her: Dex wanted to wed her to settle a family score."), _c('br'), _c('br'), _vm._v("Beth prepared herself to end their engagement—how could she have been so naive as to think Dex was really interested in a virgin like her? But Dex didn’t take no for an answer. If a diamond ring couldn’t seduce her to the altar, then he would!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jacqueline Baird\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When Jacqueline Baird is not busy writing she likes to spend her time travelling, reading and playing cards. She enjoys swimming in the sea when the weather allows. With a more sedentary lifestyle, she does visit a gym three times a week and has made the surprising discovery that she gets some of her best ideas while doing mind-numbingly boring exercises on the weight machines and airwalker. Jacqueline lives with her husband Jim in Northumberland.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0